import React from "react";
import { IModalInstance } from "@whatslly/ui-components/modals/ModalProvider";
import { BaseModal, ModalHeader } from "@whatslly/ui-components/modals";
import { AddNewFields } from "./AddNewFields";
import type { GetLayoutFieldType } from "@whatslly/types/GetLayoutOptionsResponse";
import type { LayoutFieldType } from "@whatslly/types/LayoutFieldType";
import styles from "./add-new-layout-fileds-modal.module.scss";

export const AddNewLayoutFieldsModal: React.FC<
  {
    allFields: GetLayoutFieldType[];
    selectedLayoutFieldsSetup: LayoutFieldType[];
    maxFields: number;
  } & IModalInstance
> = (props) => {
  return (
    <BaseModal
      className={styles.mainContainer}
      bodyClassName={styles.modalBody}
      closeOnClickOutside={false}
      closeOnEscape={false}
      closeModal={props.closeModal}
      header={<ModalHeader closeModal={() => props.closeModal()}></ModalHeader>}
    >
      <AddNewFields
        allFields={props.allFields}
        initialSelectedFields={props.selectedLayoutFieldsSetup}
        close={props.closeModal}
        maxFields={props.maxFields}
      />
    </BaseModal>
  );
};
